const transformObjectToFormData = (obj: any, form?: FormData, namespace = ''): FormData => {
  const formData = form || new FormData();

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const formKey = namespace ? `${namespace}[${key}]` : key;

      if (value instanceof Date) {
        formData.append(formKey, value.toISOString());
      } else if (value instanceof File || value instanceof Blob) {
        formData.append(formKey, value);
      } else if (Array.isArray(value)) {
        value.forEach((element, index) => {
          const arrayKey = `${formKey}[${index}]`;
          if (typeof element === 'object' && element !== null) {
            transformObjectToFormData(element, formData, arrayKey);
          } else {
            formData.append(arrayKey, element);
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        transformObjectToFormData(value, formData, formKey);
      } else if (value !== undefined && value !== null) {
        formData.append(formKey, value);
      }
    }
  }

  return formData;
};

const scrollToInvalidElement = () => {
  setTimeout(() => {
    const firstInvalidElement = document.querySelector('.ng-invalid');
    if (firstInvalidElement) {
      (firstInvalidElement as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      // Optionally focus the element
      if ('focus' in firstInvalidElement) {
        (firstInvalidElement as HTMLElement).focus();
      }
    }
  }, 100);
};

const isDefined = (value: any): boolean => {
  return value !== undefined && value !== null;
};

export const form = {
  transformObjectToFormData,
  scrollToInvalidElement,
  isDefined,
};
